module.exports = __webpack_public_path__ + "media/images/hero-deco-mobile-right-c1489b677bca30b3f2706683bfa22043.svg";